import React from 'react';
import { getLocalizedDateTime, getLocalizedString } from '../../localization/LocalizedString';
import './ServiceTable.css';
import formatSeconds from './TimeFormat';

const GroupedTaskListItem = ({ currentLanguage, item }) => {
  const {
    companyName,
    totalEndTime,
    totalDuration,
    streetAddress,
    city,
    relatedTasks,
    service,
    customer: {
      name: customerName,
    } = {},
  } = item;

  let serviceSiteDuration = 0;
  for (let i = 0; i < relatedTasks.length; i += 1) {
    serviceSiteDuration += relatedTasks[i].durationSeconds;
  }

  let serviceName = '';
  if (service != null && service.length > 0) {
    serviceName = service[0].name;
  }

  return (
    <tr className="report-table-row_service">
      <td className="report-table-cell_service">{getLocalizedDateTime(new Date(totalEndTime), currentLanguage)}</td>
      <td className="report-table-cell_service">{customerName}</td>
      <td className="report-table-cell_service">{companyName}</td>
      <td className="report-table-cell_service">{streetAddress}</td>
      <td className="report-table-cell_service">{city}</td>
      <td className="report-table-cell_service">{getLocalizedString(serviceName, currentLanguage)}</td>
      <td className="report-table-cell_service report-table-number">{formatSeconds(totalDuration)}</td>
      <td className="report-table-cell_service report-table-number">{formatSeconds(serviceSiteDuration)}</td>
      <td className="report-table-cell_service report-table-number">{formatSeconds(totalDuration - serviceSiteDuration)}</td>
    </tr>
  );
};

export default GroupedTaskListItem;



// WEBPACK FOOTER //
// ./src/components/servicereport/GroupedTaskListItem.js